import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/SaveAlt';
import Slide from '@material-ui/core/Slide';
import AttributeTable from './AttributeTable';
import AutoCompleteCombo from './AutoCompleteCombo';

import axios from 'axios';

import globals from '../globals';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog (props) {
    if (!props.selectedLayer) return null;
    const { classes } = props;

    const [attributes, setAttributes] = React.useState(props.attributes && [...props.attributes]);

    const onSpatialUnitSelected = (su) => {
      su ?
      axios.get(`/spatial/intersect?gid=${su.gid}&layerId=${props.selectedLayer.layerId}`).then(res => {
        const attributesObj = {};
        props.attributes.map(a => attributesObj[a.record_id] = a);

        const attributes = [];
        res.data.map(rid => {
          attributes.push(attributesObj[rid]);
        });
        setAttributes(attributes);
      })
      :
      setAttributes(props.attributes);
    }

    React.useEffect(() => {
      props.attributes && setAttributes(props.attributes);
    }, [props.attributes])

    return props.selectedLayer ? 
    (
      <div>
        <Dialog
          fullScreen
          open={props.open}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={props.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {props.selectedLayer.text} {props.selectedLayer.filtered && <span>({props.imeObjekta})</span>}
              </Typography>
              {!props.selectedLayer.filtered && <AutoCompleteCombo onItemSelected={onSpatialUnitSelected} items={globals.spatialNames}></AutoCompleteCombo>}
              <IconButton color="inherit" onClick={() => props.handleSave(attributes)} aria-label="Save">
                <SaveIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <AttributeTable data={attributes}/>
        </Dialog>
      </div>
    ) : null;
  }

export default withStyles(styles)(FullScreenDialog);